import {createApp} from 'vue';
import DevopsDashboard from '../../../js/components/DevopsDashboard.vue';

export function initDevopsDashboard() {
  const el = document.querySelector<HTMLElement>('#devops-dashboard-app');
  if (!el) return;

  const locale = JSON.parse(el.getAttribute('data-locale') ?? '{}');
  createApp(DevopsDashboard, {
    title: el.getAttribute('data-title') ?? 'DevOps Dashboard',
    dataUrl: el.getAttribute('data-data-url') ?? '',
    exportUrl: el.getAttribute('data-export-url') ?? '',
    defaultRange: el.getAttribute('data-default-range') ?? '30d',
    logoUrl: el.getAttribute('data-logo-url') ?? '/img/logo.svg',
    homeUrl: el.getAttribute('data-home-url') ?? '/',
    homeLabel: el.getAttribute('data-home-label') ?? '',
    locale,
  }).mount(el);
}
